import { ContentCopy } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';

import { getCurrentTraceId } from '@/telemetry/applicationInsights';

const TraceIdDisplay = () => {
  const traceId = getCurrentTraceId();
  if (!traceId) return null;

  const handleCopy = () => navigator.clipboard.writeText(traceId);

  return (
    <Typography
      variant="caption"
      sx={{ fontSize: '0.85rem', color: 'text.disabled' }}
    >
      Trace ID: {traceId}
      <Tooltip title="Copy trace ID">
        <IconButton
          color="opacity75"
          size="small"
          onClick={handleCopy}
          sx={{ padding: 0.5 }}
        >
          <ContentCopy sx={{ fontSize: '0.85rem' }} />
        </IconButton>
      </Tooltip>
    </Typography>
  );
};

export default TraceIdDisplay;
